var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import InfosetsMemberActionsMenu from '@/modules/infosets/components/InfosetsMemberActionsMenu.vue';
import InfosetMembersMenuContainer from '@/modules/infosets/containers/InfosetsMembersMenu.container.vue';
import EventBus from '@/shared/event-bus';
import Input from 'components/Input.vue';
import Star from 'components/Star.vue';
import UserAvatar from 'components/UserAvatar.vue';
import IconEmail from '@/components/Icons/IconEmail.vue';
import { uniqBy } from 'lodash';
import moment from 'moment';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import InfosetRemoveModal from './InfosetRemoveModal.vue';
import InfosetsDropdown from './InfosetsDropdownMenu.vue';
import AccuracyDataFeedbackModal from './AccuracyDataFeedbackModal.vue';
import InfosetsMoreListMembersMenuContainer from '@/modules/infosets/containers/InfosetsMoreListMembersMenu.container.vue';
import ModalUserHasNotPermission from '@/components/ModalUserHasNotPermission.vue';
import DataValidationModal from '../containers/DataValidationModal.vue';
import InfosetExportIframeModal from '@/modules/infosets/components/InfosetExportIframeModal.vue';
import InfosetExportModalContainer from '../containers/Exportations/InfosetExportModal.container.vue';
import { connect } from '@/overmind';
import Tooltip from '@/components/Tooltip.vue';
import { getCrmBaseUrl, hasNewExportModal, normalizeSearchIds, } from '@/shared/utils/helpers';
import { NotificationService } from '@/services/NotificationService';
let InfosetsTableRow = class InfosetsTableRow extends Vue {
    constructor() {
        super(...arguments);
        this.infosetItem = {
            id: '',
            name: '',
            members: [],
            updatedAt: 1,
            createdAt: 1,
            star: '',
            author: { id: '', name: '', email: '' },
        };
        this.filteredAvailableMembers = [];
        this.selectedMembers = [];
        this.infosetMembers = this.infoset.members || [];
        this.memberNames = [];
        this.newInfosetName = '';
        this.showModalAddUser = false;
        this.showModalEditInfoset = false;
        this.showModalRemoveInfoset = false;
        this.showExportModal = false;
        this.showLegacyExportModal = false;
        this.legacyExportFallbackTimer = null;
        this.showDataValidationModal = false;
        this.showHasNotPermissionModal = false;
        this.showMemberDetails = false;
        this.showMemberActionsMenu = false;
        this.edittingInfoset = false;
        this.infosetName = '';
        this.selectedMember = null;
        this.openAccuracyFeedback = false;
        this.hasError = false;
        this.errorMessage = '';
        this.crmButtonLoading = false;
        this.showCrmModal = false;
        this.crmModalNeedsSync = true;
        this.pendingToRequest = {
            phones: true,
            emails: true,
        };
    }
    get crmBaseUrl() {
        return getCrmBaseUrl();
    }
    get atlasToken() {
        return localStorage.getItem('auth_token_default') || '';
    }
    get crmModalTitle() {
        return this.crmModalNeedsSync ? 'Lista sendo processada' : 'Lista já no CRM';
    }
    get crmModalMessage() {
        return this.crmModalNeedsSync
            ? 'Estamos criando os negócios, decisores e tarefas no CRM. Em instantes tudo estará disponível por lá.'
            : 'Esta lista já foi exportada. Você pode abrir o CRM normalmente.';
    }
    /**
     * 1) lista vazia → toast
     * 2) verifica mudanças
     * 3) se precisa, já inicia o export no CRM
     * 4) modal só informa; botão só abre o CRM
     */
    async openCrmNative() {
        if (this.crmButtonLoading)
            return;
        const contacts = Number(this.infoset && this.infoset.contacts);
        if (!contacts || contacts <= 0) {
            NotificationService.warning('Lista vazia', 'Adicione empresas antes de exportar para o CRM.');
            return;
        }
        if (!this.atlasToken) {
            NotificationService.error('Sessão inválida', 'Faça login novamente no Atlas para exportar.');
            return;
        }
        this.crmButtonLoading = true;
        const infosetId = this.infosetItem.id;
        try {
            let needsSync = true;
            try {
                const syncCheck = await this.actionsInfosets.checkCrmSyncNeeded({
                    infosetId,
                });
                if (syncCheck && syncCheck.ok && syncCheck.needs_sync === false) {
                    needsSync = false;
                }
            }
            catch (_err) {
                needsSync = true;
            }
            this.crmModalNeedsSync = needsSync;
            if (needsSync) {
                // Começa sozinho — não espera o clique do modal.
                this.actionsInfosets
                    .exportToCrm({ listId: infosetId })
                    .then(result => {
                    if (!result || result.ok === false) {
                        NotificationService.error('Falha ao exportar', (result && result.error) ||
                            'Não foi possível enviar a lista ao CRM. Tente novamente.');
                    }
                })
                    .catch(() => {
                    NotificationService.error('Falha ao exportar', 'Não foi possível enviar a lista ao CRM. Tente novamente.');
                });
            }
            this.showCrmModal = true;
        }
        catch (_err) {
            NotificationService.error('Falha ao verificar', 'Não foi possível checar o CRM. Tente novamente.');
        }
        finally {
            this.crmButtonLoading = false;
        }
    }
    confirmCrmAction() {
        this.showCrmModal = false;
        window.open(this.buildCrmLoginUrl(this.atlasToken), '_blank');
    }
    buildCrmLoginUrl(token) {
        const redirectTo = '/crm/deals';
        return `${this.crmBaseUrl}/api/method/speedio.api.atlas_auth.login_with_token?token=${encodeURIComponent(token)}&redirect_to=${encodeURIComponent(redirectTo)}`;
    }
    accessCrm() {
        window.open(this.buildCrmLoginUrl(this.atlasToken), '_blank');
    }
    checkChanges(infoset) {
        this.infosetItem = infoset;
        this.infosetName = infoset.name;
    }
    get canShare() {
        // @ts-ignore
        return this.$auth.check(['admin', 'owner', 'manager', 'customer_success']);
    }
    get getCreationDate() {
        moment.locale('pt-BR');
        return this.infosetItem.createdAt
            ? moment(new Date(this.infosetItem.createdAt), 'YYYYMMDD').fromNow()
            : '';
    }
    get emailsNoValidate() {
        return this.infoset.emailsValidationStatus == 'not initialized';
    }
    get phonesNoValidate() {
        return ['error', 'not initialized'].includes(this.infoset.phonesValidationStatus || '');
    }
    get emailsInValidation() {
        // 'processing' é o status que o atlas-reborn escreve enquanto a
        // validação de e-mail está em andamento (mesmo motivo do
        // phonesInValidation, logo abaixo). Sem isso aqui, o ícone caía no
        // fallback "validado" (verde) assim que a validação começava, antes de
        // terminar — is_completed ainda false no reborn, mas a lista já
        // aparecia como se estivesse 100% validada.
        return ['requested', 'processing'].includes(this.infoset.emailsValidationStatus || '');
    }
    get phonesInValidation() {
        // 'processing' é o status que o atlas-reborn escreve enquanto a
        // validação de telefone está em andamento (equivalente a
        // 'requested'/'sended' do fluxo legado). Sem isso aqui, o ícone caía no
        // fallback "validado" assim que a validação começava, antes de terminar.
        return ['requested', 'sended', 'processing'].includes(this.infoset.phonesValidationStatus || '');
    }
    goToInfosetPage() {
        this.$router.push({
            name: 'infoset',
            params: { infosetId: this.infosetItem.id },
        });
        if (this.$parent)
            this.$parent.$emit('goToInfoset', this.infosetItem.id);
    }
    showEditInput() {
        this.edittingInfoset = true;
    }
    showStatsInfoset() {
        if (this.$parent)
            this.$parent.$emit('showStatsInfoset', this.infosetItem.id);
    }
    isDeleted(infoset) {
        return !!infoset.deletedAt;
    }
    starInfoset(value) {
        const stringValue = value === true ? 'true' : 'false';
        return { infosetId: this.infosetItem.id, star: stringValue };
    }
    confirmRemoveInfoset() {
        this.showModalRemoveInfoset = false;
        if (this.$parent)
            this.$parent.$emit('onRemoveInfoset', this.infosetItem.id);
    }
    getAvailableMembers() {
        //EventBus.$emit('ALL_MEMBERS_REQUEST');
        if (this.$parent)
            this.$parent.$emit('requestAllUsers', true);
    }
    goToInfosetAsMember(key) {
        this.$router.push({
            name: 'infoset',
            params: { infosetId: this.infosetItem.id },
            query: { view_as: this.infosetItem.members[key].id },
        });
    }
    async handleSpeedmailAction() {
        //@ts-ignore
        const result = await this.actionsShop.getAppPermission('speedmail');
        const hasSpeedmail = result.data.have_app;
        const handleRoute = hasSpeedmail
            ? `/shop/config/speedmail-app?infosetId=${this.infoset.id}`
            : '/shop/overview';
        this.$router.push(handleRoute);
    }
    onInfosetChange(val, _oldVal) {
        if (val) {
            this.buildInitialBadges();
        }
    }
    setNewInfosetName(name) {
        this.newInfosetName = name;
    }
    confirmEditInfoset() {
        if (this.newInfosetName && this.validateInfosetName() && this.$parent) {
            this.$parent.$emit('onEditInfoset', {
                infosetId: this.infosetItem.id,
                newValues: {
                    name: this.newInfosetName,
                },
            });
            this.showModalEditInfoset = false;
            this.edittingInfoset = false;
        }
        //@ts-ignore
        else
            return this.$refs.editInput.$refs.qinput.validate();
    }
    validateInfosetName() {
        return (this.newInfosetName.length > 0 &&
            this.newInfosetName.length <= 60 &&
            this.newInfosetName !== null &&
            this.newInfosetName !== '');
    }
    hasNoSpecialChars() {
        if (this.newInfosetName === '' || this.newInfosetName === null) {
            this.hasError = false;
            return;
        }
        const isValid = /^[a-zA-Z0-9\s/\\|\-]+$/.test(this.newInfosetName.trim());
        if (!isValid) {
            this.hasError = true;
            return 'Forneça um nome válido';
        }
        else {
            this.hasError = false;
            return;
        }
    }
    cancelEditInfosetName() {
        this.edittingInfoset = false;
        this.infosetName = this.infoset.name;
    }
    updateMembers({ member, event, }) {
        if (event) {
            this.infosetMembers.push(member);
        }
        else {
            const foundIndex = this.infosetMembers.findIndex(m => m.id === member.id);
            if (foundIndex > -1) {
                this.infosetMembers.splice(foundIndex, 1);
            }
        }
        EventBus.$emit('UPDATE_MEMBERS_REQUEST', this.infosetItem.id, this.infosetMembers);
    }
    buildInitialBadges() {
        if (this.infosetItem !== null) {
            if (this.infosetItem.members && this.infosetItem.members.length > 0) {
                let members = this.aggregateInfosetAuthorAsMember();
                this.memberNames = members
                    .slice(0, 3)
                    .map((member) => {
                    const names = member.name.split(' ');
                    const first = names[0].substr(0, 1).toUpperCase();
                    const last = names[names.length - 1].substr(0, 1).toUpperCase();
                    return first + last;
                });
            }
            else {
                if (this.infosetItem.author) {
                    if (this.infosetItem.author.name) {
                        const names = this.infosetItem.author.name.split(' ');
                        const first = names[0].substr(0, 1).toUpperCase();
                        const last = names[names.length - 1].substr(0, 1).toUpperCase();
                        const initials = first + last;
                        this.memberNames = this.memberNames.concat([initials]);
                    }
                }
            }
        }
        return '';
    }
    handleAuthorName(infoset) {
        return infoset.author && infoset.author.name
            ? infoset.author.name
            : this.currentUser.name
                ? this.currentUser.name
                : '';
    }
    async openModal() {
        if (this.shouldOpenValidationModal()) {
            this.showDataValidationModal = true;
        }
        else {
            this.openExportModal();
        }
    }
    async openExportModal() {
        //@ts-ignore
        if (this.userActions.canOpenExportModal()) {
            // Gate da feature flag: só as contas liberadas abrem o modal novo
            // (iframe do atlas-reborn). As demais vão direto para o modal antigo,
            // sem piscar o iframe na tela.
            // Um fallback pendente de uma abertura anterior não pode ressuscitar o
            // modal antigo por cima deste.
            this.clearLegacyExportFallback();
            // @ts-ignore TS2349: $auth injetado pelo vue-auth
            if (hasNewExportModal(this.$auth.user())) {
                this.showExportModal = true;
            }
            else {
                this.showLegacyExportModal = true;
            }
            this.$emit('setCurrentInfoset', this.infosetItem.id);
        }
        else {
            this.showHasNotPermissionModal = true;
        }
    }
    /**
     * Rede de segurança do gate: o iframe avisou que esta conta não deve ver o
     * modal novo (sem a flag, /user/me indisponível ou o próprio reborn fora do
     * ar). Fecha o iframe e abre a exportação antiga.
     *
     * O delay espera o QDialog do iframe terminar de sair: abrir o modal antigo
     * no mesmo tick faz os dois disputarem o focus trap e o scroll lock do
     * Quasar.
     */
    fallbackToLegacyExport() {
        this.showExportModal = false;
        this.clearLegacyExportFallback();
        this.legacyExportFallbackTimer = setTimeout(() => {
            this.legacyExportFallbackTimer = null;
            this.showLegacyExportModal = true;
        }, 300);
    }
    clearLegacyExportFallback() {
        if (this.legacyExportFallbackTimer) {
            clearTimeout(this.legacyExportFallbackTimer);
            this.legacyExportFallbackTimer = null;
        }
    }
    beforeDestroy() {
        this.clearLegacyExportFallback();
    }
    shouldOpenValidationModal() {
        // @ts-ignore
        const user = this.$auth.user();
        if (user && user.accountType && user.accountType == 'free')
            return false;
        if (this.infoset.contacts == 0)
            return false;
        if (
        // 'processing'/'completed' são os status do atlas-reborn; sem eles
        // aqui, uma lista validada (ou em validação) pelo reborn recentemente
        // era tratada como pendente e o modal de "validar novamente?" abria
        // sem necessidade.
        ['requested', 'sended', 'finished', 'processing', 'completed'].includes(this.infoset.phonesValidationStatus || '') &&
            this.lessThanThirtyDays(this.infoset.phonesValidationStartedAt)) {
            this.pendingToRequest.phones = false;
        }
        if (['requested', 'sended', 'finished'].includes(this.infoset.emailsValidationStatus || '') &&
            this.lessThanThirtyDays(this.infoset.emailsValidationStartedAt)) {
            this.pendingToRequest.emails = false;
        }
        return this.pendingToRequest.emails || this.pendingToRequest.phones;
    }
    closeValidationModal(value) {
        if (value.continue) {
            this.openExportModal();
        }
        else {
            if (this.pendingToRequest.phones) {
                this.infosetItem.phoneValidationStatus = 'requested';
                this.infosetItem.phonesValidationStartedAt = new Date();
            }
            if (this.pendingToRequest.emails) {
                this.infosetItem.emailsValidationStatus = 'requested';
                this.infosetItem.emailsValidationStartedAt = new Date();
            }
        }
    }
    lessThanThirtyDays(date) {
        if (!date)
            return true;
        const inputDate = new Date(date);
        const today = new Date();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(today.getDate() - 30);
        return inputDate >= thirtyDaysAgo && inputDate <= today;
    }
    aggregateInfosetAuthorAsMember() {
        let members = this.infosetItem && this.infosetItem.members
            ? this.infosetItem.members.slice(0, 2)
            : [];
        if (this.infoset.author) {
            members = members.concat([this.infoset.author]).reverse();
            return uniqBy(members, 'id');
        }
        return members;
    }
    get memberIsInfosetAuthor() {
        return (member) => {
            if (this.infoset.author && member)
                return this.infoset.author.id === member.id;
            return false;
        };
    }
    get maxAvatarCountVisibleAllowed() {
        if (this.infoset.members) {
            return this.infoset.members.slice(0, 2).length;
        }
        return 0;
    }
    get infosetMembersCount() {
        if (this.infoset.members) {
            return this.infoset.members.length;
        }
        return 0;
    }
    async mounted() {
        this.buildInitialBadges();
    }
    handleShowMemberActionsMenu(member) {
        this.selectedMember = member;
        this.showMemberActionsMenu = !this.showMemberActionsMenu;
    }
    openSearches() {
        // A API devolve os ids em duas formas conforme o endpoint (Extended JSON no
        // Rails, hex no atlas-reborn); ler `.$oid` direto abriria /search/undefined
        // sem nenhum erro visivel no dia em que a listagem migrar.
        const searchIds = normalizeSearchIds(this.infoset.search_ids);
        searchIds.forEach(searchId => {
            window.open('/search/' + searchId, '_blank', 'noopener');
        });
    }
    openAccuracyDataFeedback() {
        this.openAccuracyFeedback = true;
    }
    recoverInfoSet(id) {
        this.$emit('recoverInfoSet', id);
    }
    get showWhatsappEnrichmentIcon() {
        // @ts-ignore
        const user = this.$auth.user();
        return (user && user.features && user.features.includes('enrichment_whatsapp'));
    }
    get hasCrm_atlas() {
        // @ts-ignore
        const user = this.$auth.user();
        return (user &&
            Array.isArray(user.features) &&
            user.features.includes('crm_atlas'));
    }
};
__decorate([
    Prop({ default: () => { } })
], InfosetsTableRow.prototype, "infoset", void 0);
__decorate([
    Prop({ default: () => [] })
], InfosetsTableRow.prototype, "availableMembers", void 0);
__decorate([
    Prop({ default: () => [] })
], InfosetsTableRow.prototype, "filteredMembers", void 0);
__decorate([
    Prop({ default: false })
], InfosetsTableRow.prototype, "loadingToExportCsv", void 0);
__decorate([
    Prop({ default: () => { } })
], InfosetsTableRow.prototype, "currentUser", void 0);
__decorate([
    Watch('infoset', { deep: true, immediate: true })
], InfosetsTableRow.prototype, "checkChanges", null);
__decorate([
    Emit('starInfoset')
], InfosetsTableRow.prototype, "starInfoset", null);
__decorate([
    Watch('infoset')
], InfosetsTableRow.prototype, "onInfosetChange", null);
InfosetsTableRow = __decorate([
    Component(connect(({ actions }) => ({
        userActions: actions.users,
        actionsInfosets: actions.infosets,
        actionsCompany: actions.companies,
        actionsShop: actions.shop,
    }), {
        name: 'InfosetsTableRow',
        components: {
            UserAvatar,
            Star,
            Input,
            IconEmail,
            InfosetMembersMenuContainer,
            InfosetsDropdown,
            InfosetRemoveModal,
            InfosetsMemberActionsMenu,
            InfosetsMoreListMembersMenuContainer,
            ModalUserHasNotPermission,
            AccuracyDataFeedbackModal,
            DataValidationModal,
            InfosetExportIframeModal,
            InfosetExportModalContainer,
            Tooltip,
        },
    }))
], InfosetsTableRow);
export default InfosetsTableRow;
